import { fun_PostAction, fun_GetAction, fun_Download } from "@/api/index";
import { fun_GetKeys } from "../../../../utils/validate";
import PrintDialog from "../../components/PrintDialog/index.vue";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单字段
      form: {
        tenderPrjName: null, // 项目名称
        constructionNo: null, // 报建编号
        registrationId: null, // 招标登记编号
        announcementId: null, // 招标公告编号
        prjbuildCorpName: null, // 项目招标单位
        agencyCorpName: null, // 招标代理单位
        noticeStartDate: null, // 文件下载开始时间
        noticeState: null, // 公告状态
        pageState: null, // 状态
        regulators: null, // 行政监督部门
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "tenderPrjName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "行政监督部门：",
          value: "regulators",
          placeholder: "请选择",
          disabled: false,
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201510311952460006"
          }
        },
        {
          type: "input",
          label: "项目招标单位：",
          value: "prjbuildCorpName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "公告状态：",
          value: "noticeState",
          placeholder: "请输入",
          optionData: [
            {
              name: "正常",
              value: "0"
            },
            {
              name: "延期",
              value: "1"
            },
            {
              name: "暂停",
              value: "2"
            },
            {
              name: "作废",
              value: "3"
            },
          ]
        },
      ],
      // 表格按钮
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        },
      ],
      // 列表数据
      tableData: [],
      // 列表基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "tenderPrjName",
          isShow: true,
          width: "300",
          fixed: true,
          align: "left",
        },
        {
          label: "状态",
          slotName: "state",
          width: "150",
          fixed: true,
          align: "left",
        },
        {
          label: "打印",
          slotName: "print",
          width: "120",
          fixed: true,
          align: "left",
        },
       
        {
          label: "公告状态",
          prop: "noticeStateName",
          width: "100",
          align: "left",
        },
        {
          label: "申请变更公告状态",
          slotName: "modifyNoticeStateName",
          width: "160",
          align: "left",
        },
        {
          label: "项目招标单位",
          prop: "prjbuildCorpName",
          width: "250",
        },
        {
          label: "评标办法",
          prop: "evaluationMethodName",
          width: "300",
        },
        {
          label: "本次招标投资额（万元）",
          prop: "totalInvestment",
          width: "200",
        },
        {
          label: "招标投标监管部门",
          prop: "regulators",
          width: "300",
        }
      ],
      // 温馨提示
      tipList: [
        /* {
           type: "text",
           text: "（1）“招标/资格预审公告”登记前，须先完成“招标登记”。",
         },
         {
           type: "text",
           text: "（2）新增：点击“添加”；修改：勾选对应项目，点击“修改”；删除：勾选对应项目，点击“删除”。",
         },
         {
           type: "text",
           text: "（3）当状态为“招标人确认中”时，招标人请点击项目名称进入详情后进行操作。",
         },
         {
           type: "text",
           text: "（4）电子交易平台不对投标人（申请人）的企业资格和拟投入的项目负责人的资格及在建工程情况进行限制。请投标人（申请人）在下载操作时，以招标公告（资格预审公告）载明的相关要求为主，以免在后期交易过程中造成投标损失。",
         },
         {
           type: "AdobeReader",
         },*/
       ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 总条数
      total: 0,
      userFlag: sessionStorage.getItem("userFlag"), // 用户标识
      // 选中的数组
      multipleSelection: []
    }
  },
  // 注册组件
  components: {
    PrintDialog, // 打印
  },
  // 模板编译完成
  mounted() {
    // 如果用户标识是工作人员或者监管人员
    if (this.userFlag === "工作人员" || this.userFlag === "监管人员" || this.userFlag === "分包合同监管人员") {
      // 登录用户是监管人员或分包合同监管人员
      if (this.yhbs === "监管人员" || this.yhbs == "分包合同监管人员") {
        // 遍历
        this.formSearchList.map(e => {
          // 匹配行政监督部门
          if (e.value === "regulators") {
            // 置灰
            e.disabled = true;
            // 赋值为登录用户的区管代码
            this.form.regulators = "01";
          }
        });
      };
      // 工作人员
      if (this.userFlag === "工作人员") {
        // 报表导出
        this.btnList = [
          {
            type: "slot",
            slotName: "export",
          }
        ]
      } else {
        // 清空表头
        this.btnList = [];
      }
    }
    // 执行获取列表数据方法
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开遮罩
      this.loading = true;
      // 发起请求
      fun_PostAction("/tendererNotice/list", {
        ...this.form,
        ...this.reqPageData
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.tableData = data.records;
          // 总条数
          this.total = data.total;
          // 关闭遮罩层
          this.loading = false;
        } else {
          // 关闭遮罩层
          this.loading = false;
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 打印的方法
     * @author shuhua
     */
    fun_DialogForPrint(data) {
      // 打开弹窗
      this.$refs.printDialog.dialogVisible = true;
      // 主键
      this.$refs.printDialog.id = data.id;
      // 编号
      this.$refs.printDialog.everyIds = data.registrationId;
      // ids
      this.$refs.printDialog.data = data.id;
      // ids
      this.$refs.printDialog.agencyId = data.agencyId;
      // 权限编号
      this.$refs.printDialog.operationNum = "201606061508000007";
      // 招标人且是委托招标
      if(sessionStorage.getItem("loginType") == "201904241041160002" && data.tenderMethod ==='2'){
        // 不显示加盖签章
        this.$refs.printDialog.showBtn = false;
      }
    },
    
    /**
     * 打印的方法
     */
     fun_DialogPrint(id,agency,tender,agencyRecords,bidder,lock,recordNumber) {
      // 发起请求
      fun_Download("/dialogPrint", {
        controller: "tendererNoticePrint",
        id: id,
        agency: agency,
        tender: tender,
        agencyRecords: agencyRecords,
        lock: lock,
        recordNumber: recordNumber
      }).then(res => {
        const data = new Blob([res.data], { type: "application/pdf" });
        const reader = new FileReader();
        // 如果文件大小等于0
        if(data.size == 0){
          this.$message.success("文件生成中！");
        }else{
          //
          this.$refs.printDialog.isShow = true;
          // 读取文件
          reader.readAsText(data);
          // 触发onload事件
          reader.onload = () => {
            // json格式数据转换成对象
            if (reader.result.indexOf("result") > -1) {
              const result = JSON.parse(reader.result);
              if (result.result == false) {
                this.$message.error(result.msg);
              }
            } else {
              this.$refs.printDialog.pdfUrl =
                  "./static/pdf/web/viewer.html?file=" +
                  encodeURIComponent(URL.createObjectURL(data));
            }
          };
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author shuhua
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 跳转详情页面
          this.$router.push({
            path: "/tendererNoticeDetail",
            // 操作类型
            query: { controllerFlg: "insert" }
          });
          break;
        case "修改":
          // 执行修改的方法
          this.fun_Edit();
          break;
        case "删除":
          // 执行删除的方法
          this.fun_Del();
          break;
      }
    },
    /**
     * 编辑的方法
     */
    fun_Edit() {
      // 有勾选的数据
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 核验状态
          let state = '';
          // 公告状态
          let noticeState = false;
          // 是否显示
          let visible = false;
          // 甲方确认信息编号
          let tenderSignedId = '';
          // 甲方确认状态
          let tenderSignedState = '';
          // 是否为甲方
          let tenderCorpFlag = "";
          // 招标组织形式
          let tenderMethod = "";
          // 遍历
          this.multipleSelection.forEach(e => {
            // 状态
            state = e.state;
            // 招标人确认id
            tenderSignedId = e.tenderSignedId;
            // 招标人确认状态
            tenderSignedState = e.tenderSignedState;
            // 是否为甲方
            tenderCorpFlag = e.tenderCorpFlag;
            // 招标组织形式
            tenderMethod = e.tenderMethod;
            // 公告核验状态为作废且核验通过或者提交
            if (e.noticeState === '3' && (e.state === 'tg' || e.state === 'tj') && e.tenderSignedId === 'tg') {
              // 公告状态
              noticeState = true;
            }
            // 显示
            if (e.visible == '1') {
              // 是否显示
              visible = true;
            }
          });
          // 邀请招标
          if (visible) {
            // 错误消息提示
            this.$alert("邀请招标，不可修改！", "warning");
            return;
          }
          // 公告状态为提交或者核验已通过的不能删除
          if (noticeState) {
            // 错误消息提示
            this.$alert(
              "您选择的招标公告的公告状态为作废，不能修改和删除！",
              "warning"
            );
            return;
          }
          // 如果招标组织形式不是自行组织
          if (tenderMethod !== '' && tenderMethod !== null && tenderMethod !== '1') {
            // 则验证若是招标人则不能修改操作
            if (tenderCorpFlag === '01') {
              // 错误消息提示
              this.$alert(
                "该项目为委托招标请直接点击项目进入详情进行操作，不能修改项目数据。",
                "warning"
              );
              return;
            }
          }
          // 状态名称
          let stateName = "";
          // 检查状态
          let rtn = true;
          // 提交的场合
          if (state == 'tj') {
            // 状态名称
            stateName = "提交";
            // 存在甲方确认信息的场合
            if (tenderSignedId != '' && tenderSignedId != null) {
              // 盖章信息为空的场合
              if (tenderSignedState == 'tj') {
                // 状态名称
                stateName = '招标人确认中';
                // 操作标识
                rtn = false;
              } else if (tenderSignedState == 'tg') {
                // 状态名称
                stateName = '提交';
                // 操作标识
                rtn = false;
              } // 去监管化后的新增判断逻辑判断
              else if (tenderSignedState == 'bc') {
                // 状态名称
                stateName = '提交';
                // 操作标识
                rtn = false;
              }
            } else {
              rtn = false;
            }
          }
          // 若选中行中包含已核验通过的数据行，则提示不能删除
          if (!rtn) {
            // 错误消息提示
            this.$alert(
              "该项目当前状态为“" + stateName + "”，不能修改！",
              "warning"
            );
            return;
          } else {
            // 跳转详情页面
            this.$router.push({
              path: "/tendererNoticeDetail",
              // 操作类型
              query: {
                id: this.multipleSelection[0].id,
                controllerFlg: "update"
              }
            });
          }
        }
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 删除的方法
     * @author shuhua
     */
    fun_Del() {
      // 有勾选的数据
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 核验状态
          let state = "";
          // 公告状态
          let noticeState = false;
          // 是否显示
          let visible = false;
          // 甲方确认信息编号
          let tenderSignedId = "";
          // 甲方确认状态
          let tenderSignedState = "";
          // 核验通过的标志
          let isAuditOk = false;
          // 是否为甲方
          let tenderCorpFlag = "";
          // 招标组织形式
          let tenderMethod = "";
          // 遍历
          this.multipleSelection.forEach(e => {
            // 公告核验状态为作废且核验通过或者提交
            if (e.noticeState === '3' && (e.state == 'tg' || e.state == 'tj')) {
              // 公告状态
              noticeState = true;
            }
            // 显示
            if (e.visible == '1') {
              // 是否显示
              visible = true;
            }
            // 核验状态
            if (e.isAuditOk == 'tg') {
              // 核验状态
              isAuditOk = true;
            }
            // 状态
            state = e.state;
            // 甲方确认信息编号
            tenderSignedId = e.tenderSignedId;
            // 甲方确认状态
            tenderSignedState = e.tenderSignedState;
            // 如果招标组织形式不是自行组织
            if (e.tenderMethod !== '' && e.tenderMethod !== null && e.tenderMethod !== '1') {
              // 则验证若是招标人则不能修改操作
              if (e.tenderCorpFlag === "01") {
                // 是否为甲方
                tenderCorpFlag = e.tenderCorpFlag;
                // 招标组织形式
                tenderMethod = e.tenderMethod;
              }
            }
          });
          // 邀请招标
          if (visible) {
            // 错误消息提示
            this.$alert("邀请招标，不可删除！", "warning");
            return;
          }
          // 公告状态为提交或者核验已通过的不能删除
          if (noticeState) {
            // 错误消息提示
            this.$alert("您选择的招标公告的公告状态为作废，不能修改和删除！", "warning");
            return;
          }
          // 如果招标组织形式不是 自行组织
          if (tenderMethod !== '' && tenderMethod !== null && tenderMethod !== '1') {
            // 则验证若是招标人则不能修改操作
            if (tenderCorpFlag === '01') {
              // 错误消息提示
              this.$alert(
                "该项目为委托招标请联系招标代理做删除操作。",
                "warning"
              );
              return;
            }
          }
          // 状态名称
          let stateName = "";
          // 检查状态
          let checkFlg = true;
          // 提交的场合
          if (state == 'tj') {
            // 状态名称
            stateName = "提交";
            // 存在甲方确认信息的场合
            if (tenderSignedId != '' && tenderSignedId != null) {
              // 盖章信息为空的场合
              if (tenderSignedState == 'tj') {
                // 状态名称
                stateName = '招标人确认中';
                // 检查状态
                checkFlg = false;
              }
            } else {
              // 检查状态
              checkFlg = false;
            }
          }
          // 验证失败的场合
          if (!checkFlg) {
            // 错误消息提示
            this.$alert('该项目当前状态为“' + stateName + '”，不能修改！', "warning");
            return;
          }
          // 公告状态为提交或者核验已通过的不能删除
          if (state === 'tg' || state === 'tj') {
            // 错误消息提示
            this.$alert(
              "您选择的招标公告状态存在已提交或者核验通过的数据，不能删除！",
              "warning"
            );
            return;
          }
          // 已核验
          if (isAuditOk) {
            // 错误消息提示
            this.$alert(
              "您选择的招标公告状态存在核验通过的记录，不能删除！",
              "warning"
            );
            return;
          }
          // 获取keys
          const keys = fun_GetKeys(this.multipleSelection);
          // 发起请求
          fun_GetAction("/tendererNotice/delete?keys=" + keys).then(res => {
            // 解构res.data
            const { result, msg } = res.data;
            // 操作成功
            if (result) {
              // 重新加载列表
              this.fun_GetList();
              // 操作成功
              this.$message.success(msg);
            } else {
              // 错误消息提示
              this.$message.error(msg);
            }
          });
        });
      } else {
        // 未勾选，则提示
        this.$alert("请选择一条数据！", "warning");
      }
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值
      this.multipleSelection = e;
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * @description 进入详情
     * @author
     */
    fun_Details(e) {
      // 跳转详情页面
      this.$router.push({
        path: "/tendererNoticeDetail",
        // 操作类型
        query: {
          id: e.val.id,
          isTenderSignature: e.val.tenderSignedState ? "1" : "",
          controllerFlg: "detail"
        }
      });
    },
  }
}